import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Structure/Sidebar';
import { Modal, Button } from 'react-bootstrap';
import { FaCloudUploadAlt, FaFileAlt, FaSpinner, FaTrash } from 'react-icons/fa';
import { getOcrDataAPI } from '../../@redux/Action/OCRAction';
import { useDispatch, useSelector } from 'react-redux';
import { MenuItem } from '@mui/material';
import { CustomTextField } from '../../utils/Fields';
import { StudentUpdates } from '../../@redux/Action/Student';
import { getUserDetail } from '../../@redux/Action/UserAction';
import { uploadFile, uploadOfferLetter } from '../../@redux/Action/docAction';
import { kycActionForStudent } from '../../@redux/Action/Kyc';



const countryOptions = [
    { value: "India", label: "India" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Canada" },
    { value: "Australia", label: "Australia" },
    { value: "UK", label: "UK" },
];

const selfDocuments = ["pan", "student_passport front", "student_passport back", "offer_letter"];

function Profile({studentId}) {
    const dispatch = useDispatch();
    const ocrDataStud = useSelector((state) => state.ocr?.ocrData);
    const offerLetterDataStud = useSelector((state) => state.documents?.offerLetterDataStudent);
    const panData = useSelector((state) => state.documents?.panData);
    const passportDataFrontStudent = useSelector((state) => state.documents?.passportDataFrontStudent);
    const passportDataBackStudent = useSelector((state) => state.documents?.passportDataBackStudent);
    const userPhoneNo = useSelector((state) => state.config?.userPhoneNo);
    const userEdit = useSelector((state) => state.user?.userEdit);
    const userData = useSelector((state) => state.user?.userData);
    console.log("offerLetterDataStud", offerLetterDataStud);
    console.log("panData", panData);
    console.log("passportDataFrontStudent", passportDataFrontStudent);
    console.log("passportDataBackStudent", passportDataBackStudent);

    const [showModal, setShowModal] = useState(false);
    const [isDataLoaded, setIsDataLoaded] = useState(userEdit !== 1);
    const [ocrData, setOcrData] = useState();
    const [studentDetails, setStudentDetails] = useState({
        first_name: "",
        last_name: "",
        email: "",
        dob: "",
        street_address: "",
        country: "",
        city: "",
        state: "",
        pincode: "",
        passport_number: "",
        pan_number: "",
        phone: userPhoneNo,
        isd_code: "+91",
        offer_letter_doc: offerLetterDataStud || "offer_letter.pdf"
    });
    const [files, setFiles] = useState({});
    const [uploadProgress, setUploadProgress] = useState({});
    const [uploadedDocs, setUploadedDocs] = useState({
        pan: false,
        student_passport_front: false,
        student_passport_back: false,
        offer_letter: false
    });

    useEffect(() => {
        if (userEdit === 0) {
            dispatch(getUserDetail(studentId));
        }
    }, [, userEdit, studentId, dispatch]);

    useEffect(() => {
        if (userEdit === 0 && userData) {
            setStudentDetails({
                first_name: userData.first_name || "",
                last_name: userData.last_name || "",
                email: userData.email || "",
                dob: userData.dob ? new Date(userData.dob).toISOString().split('T')[0] : "",
                street_address: userData.street_address || "",
                country: userData.country || "",
                city: userData.city || "",
                state: userData.state || "",
                pincode: userData.pincode || "",
                passport_number: userData.passport_number || "",
                pan_number: userData.pan_number || "",
                phone: userData.phone || userPhoneNo,
                isd_code: "+91",
                offer_letter_doc: userData.offer_letter_doc || "offer_letter.pdf"
            });
        } else if (ocrData) {
            setStudentDetails((prevDetails) => ({
                ...prevDetails,
                first_name: ocrData.First_name || prevDetails.first_name,
                last_name: ocrData.Surname || prevDetails.last_name,
                email: ocrData.Email || prevDetails.email,
                dob: ocrData.Date_of_Birth ? new Date(ocrData.Date_of_Birth).toISOString().split('T')[0] : prevDetails.dob,
                street_address: ocrData.Address || prevDetails.street_address,
                country: ocrData.Country ? ocrData.Country.toLowerCase() : prevDetails.country,
                city: ocrData.Place_of_Birth || prevDetails.city,
                state: ocrData.State || prevDetails.state,
                pincode: ocrData.Pin_code || prevDetails.pincode,
                passport_number: ocrData.Passport_number || prevDetails.passport_number,
                pan_number: ocrData.Pan_number || prevDetails.pan_number,
                phone: prevDetails.phone,
                isd_code: prevDetails.isd_code
            }));
        }
    }, [ocrData, userData, userEdit, userPhoneNo]);

    useEffect(() => {
        // Check if all required documents including offer letter are uploaded
        if (uploadedDocs.pan && uploadedDocs.student_passport_front && uploadedDocs.student_passport_back && uploadedDocs.offer_letter) {
            fetchOCRData(studentId);
            setShowModal(false); // Close modal when all docs are uploaded
        }
    }, [uploadedDocs]);

    const handleUploadDocs = () => {
        setShowModal(true);
    };

    const handleModalClose = () => {
        setShowModal(false);
    };

    const handleFileChange = async (e, docType) => {
        const file = e.target.files[0];
        setFiles((prevFiles) => ({
            ...prevFiles,
            [docType]: file,
        }));

        if (docType === 'offer_letter') {
            await dispatch(uploadOfferLetter(file, studentId));
        }

        dispatch(uploadFile(file, docType, studentId));

        let progress = 0;
        const interval = setInterval(() => {
            progress += 10;
            setUploadProgress((prev) => ({
                ...prev,
                [docType]: progress,
            }));
            if (progress >= 100) {
                clearInterval(interval);
                setIsDataLoaded(true);
                
                // Update uploaded docs status
                if (docType === 'pan') {
                    setUploadedDocs(prev => ({...prev, pan: true}));
                } else if (docType === 'student_passport front') {
                    setUploadedDocs(prev => ({...prev, student_passport_front: true}));
                } else if (docType === 'student_passport back') {
                    setUploadedDocs(prev => ({...prev, student_passport_back: true}));
                } else if (docType === 'offer_letter') {
                    setUploadedDocs(prev => ({...prev, offer_letter: true}));
                }
            }
        }, 200);
    };

    const fetchOCRData = async (studentId) => {
        try {
            const ocrData = await dispatch(getOcrDataAPI(studentId));
            console.log("OCR DATA", ocrData.student);
            setOcrData(ocrData.student);
        } catch (error) {
            console.error("Error fetching OCR data:", error);
        }
    };

    const handleRemoveFile = (docType) => {
        setFiles((prevFiles) => {
            const newFiles = { ...prevFiles };
            delete newFiles[docType];
            return newFiles;
        });
        setUploadProgress((prevProgress) => {
            const newProgress = { ...prevProgress };
            delete newProgress[docType];
            return newProgress;
        });
        
        // Reset uploaded doc status when file is removed
        if (docType === 'pan') {
            setUploadedDocs(prev => ({...prev, pan: false}));
        } else if (docType === 'student_passport front') {
            setUploadedDocs(prev => ({...prev, student_passport_front: false}));
        } else if (docType === 'student_passport back') {
            setUploadedDocs(prev => ({...prev, student_passport_back: false}));
        } else if (docType === 'offer_letter') {
            setUploadedDocs(prev => ({...prev, offer_letter: false}));
        }
    };

    const renderDocumentUpload = (docType) => (
        <div key={docType} className='col-md-3 mb-3'>
            <div className="card h-100">
                <div className="card-body p-2">
                    <h6 className="card-title mb-2 d-flex align-items-center small">
                        {docType.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                    </h6>
                    {!files[docType] ? (
                        <div
                            className="upload-area p-2 text-center border rounded cursor-pointer d-flex flex-column justify-content-center align-items-center"
                            onClick={() => document.getElementById(docType).click()}
                            style={{ height: '80px', background: '#f8f9fa', width: '100%' }}
                        >
                            <input
                                id={docType}
                                type="file"
                                onChange={(e) => handleFileChange(e, docType)}
                                className="d-none"
                                accept=".pdf,.jpg,.jpeg,.png"
                            />
                            <FaCloudUploadAlt className="text-muted mb-1" size={18} />
                            <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Click to upload</p>
                            <small className="text-muted" style={{ fontSize: '0.65rem' }}>PDF, JPG, PNG</small>
                        </div>
                    ) : (
                        <div className="file-info p-2 bg-light rounded d-flex flex-column justify-content-center align-items-center" style={{ height: '80px', width: '100%' }}>
                            <div className="text-center mb-1">
                                <FaFileAlt className="text-success mb-1" size={14} />
                                <p className="mb-1 small text-truncate" style={{ maxWidth: '100%', fontSize: '0.75rem' }}>{files[docType].name}</p>
                                <button className="btn btn-sm btn-outline-danger py-0" onClick={() => handleRemoveFile(docType)}>
                                    <FaTrash size={10} />
                                </button>
                            </div>
                            {uploadProgress[docType] > 0 && uploadProgress[docType] < 100 && (
                                <div className="text-center">
                                    <FaSpinner className="fa-spin text-success mb-1" size={14} />
                                    <p className="mb-0 small" style={{ fontSize: '0.65rem' }}>Uploading... {uploadProgress[docType]}%</p>
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );

    const handleInputChange = (e, field) => {
        setStudentDetails({ ...studentDetails, [field]: e.target.value });
    };

    const handleSelectChange = (e, field) => {
        setStudentDetails({ ...studentDetails, [field]: e.target.value });
    };

    const handleSave = async () => {
        try {
            console.log("studentDetails:- ", studentDetails);
            await dispatch(StudentUpdates(studentId, studentDetails));
            
            // Prepare KYC data
            const kycData = {
                user_id: studentId,
                owner_type: "User", 
                doc_relation: "student",
                ppf_doc_url: passportDataFrontStudent,
                ppb_doc_url: passportDataBackStudent,
                pan_doc: panData
            };

            // Call KYC action
            await dispatch(kycActionForStudent(kycData));

            // Refresh user details
            dispatch(getUserDetail(studentId));

        } catch (error) {
            console.error("Error updating student details:", error);
        }
    };

    return (
        <div className='d-md-flex' style={{ height: '100vh' }}>
            <Sidebar />

            <div className='col-12 col-md-9 px-4 rounded-4 d-flex flex-column overflow-auto linear-background-color'>
                <h1 className='fw-bold animate__animated animate__pulse text-success'>Profile</h1>
                <div className='my-auto mx-auto text-success position-relative' style={{width: '100%'}}>
                    <div className="mt-3 position-relative">
                        {/* Phone number field always visible and readonly */}
                        <div className="d-flex flex-wrap justify-content-between gap-3 mb-4">
                            <div className="form-group" style={{ flexBasis: "30%" }}>
                                <div className="d-flex gap-2">
                                    <CustomTextField
                                        id="outlined-select-isd"
                                        label="ISD"
                                        variant="outlined"
                                        style={{ width: '30%' }}
                                        value={studentDetails.isd_code}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        required
                                    />
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="Phone Number"
                                        variant="outlined"
                                        style={{ width: '70%' }}
                                        value={studentDetails.phone}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group" style={{ flexBasis: "30%" }}>
                                <div className="d-flex gap-2">
                                   <CustomTextField
                                        id="outlined-basic"
                                        label="Email"
                                        type="email"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.email || ""}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="form-group" style={{ flexBasis: "30%" }}></div>
                        </div>

                        {userEdit === 1 && !isDataLoaded && (
                            <div className="position-absolute top-50 start-50 translate-middle" style={{ zIndex: 1 }}>
                                <Button variant='success' onClick={handleUploadDocs} className='mb-3'>
                                    Upload Docs
                                </Button>
                            </div>
                        )}
                        <div style={{ filter: !isDataLoaded ? 'blur(5px)' : 'none', position: 'relative', zIndex: 0, pointerEvents: !isDataLoaded ? 'none' : 'auto' }}>
                            <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="First Name (Given Name)"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.first_name || ""}
                                        onChange={(e) => handleInputChange(e, "first_name")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="Last Name (Family Name)"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.last_name || ""}
                                        onChange={(e) => handleInputChange(e, "last_name")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="DOB"
                                        type="date"
                                        variant="outlined"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        value={studentDetails.dob || ""}
                                        onChange={(e) => handleInputChange(e, "dob")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                               
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="Street Address"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.street_address || ""}
                                        onChange={(e) => handleInputChange(e, "street_address")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-select-country"
                                        select
                                        label="Country"
                                        value={studentDetails.country || ""}
                                        onChange={(e) => handleSelectChange(e, "country")}
                                        variant="outlined"
                                        fullWidth
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    >
                                        {countryOptions.map((option) => (
                                            <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                            </MenuItem>
                                        ))}
                                    </CustomTextField>
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="City/District"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.city || ""}
                                        onChange={(e) => handleInputChange(e, "city")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>  
                            </div>
                            <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                               
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="State"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.state || ""}
                                        onChange={(e) => handleInputChange(e, "state")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="Pincode"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.pincode || ""}
                                        onChange={(e) => handleInputChange(e, "pincode")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="PAN Number"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.pan_number || ""}
                                        onChange={(e) => handleInputChange(e, "pan_number")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                            </div>
                            <div className="d-flex flex-wrap justify-content-between gap-3 mb-3">
                                <div className="form-group" style={{ flexBasis: "30%" }}>
                                    <CustomTextField
                                        id="outlined-basic"
                                        label="Passport Number"
                                        variant="outlined"
                                        fullWidth
                                        value={studentDetails.passport_number || ""}
                                        onChange={(e) => handleInputChange(e, "passport_number")}
                                        InputProps={{
                                            readOnly: userEdit === 0,
                                        }}
                                        required
                                    />
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="position-fixed bottom-0 end-0 mb-4 me-4">
                        <Button 
                            variant='success' 
                            onClick={handleSave}
                            disabled={userEdit === 0}
                        >
                            Save
                        </Button>
                    </div>
                </div>
            </div>

            <Modal show={showModal} onHide={handleModalClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Upload Documents</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p>Please upload your documents.</p>
                    <div className="row">
                        {selfDocuments.map((docType) => (
                            <div key={docType} className='col-md-6 mb-3'>
                                <div className="card h-100">
                                    <div className="card-body p-2">
                                        <h6 className="card-title mb-2 d-flex align-items-center small">
                                            {docType.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
                                        </h6>
                                        {!files[docType] ? (
                                            <div
                                                className="upload-area p-2 text-center border rounded cursor-pointer d-flex flex-column justify-content-center align-items-center"
                                                onClick={() => document.getElementById(docType).click()}
                                                style={{ height: '80px', background: '#f8f9fa', width: '100%' }}
                                            >
                                                <input
                                                    id={docType}
                                                    type="file"
                                                    onChange={(e) => handleFileChange(e, docType)}
                                                    className="d-none"
                                                    accept=".pdf,.jpg,.jpeg,.png"
                                                />
                                                <FaCloudUploadAlt className="text-muted mb-1" size={18} />
                                                <p className="mb-0 small" style={{ fontSize: '0.75rem' }}>Click to upload</p>
                                                <small className="text-muted" style={{ fontSize: '0.65rem' }}>PDF, JPG, PNG</small>
                                            </div>
                                        ) : (
                                            <div className="file-info p-2 bg-light rounded d-flex flex-column justify-content-center align-items-center" style={{ height: '80px', width: '100%' }}>
                                                <div className="text-center mb-1">
                                                    <FaFileAlt className="text-success mb-1" size={14} />
                                                    <p className="mb-1 small text-truncate" style={{ maxWidth: '100%', fontSize: '0.75rem' }}>{files[docType].name}</p>
                                                    <button className="btn btn-sm btn-outline-danger py-0" onClick={() => handleRemoveFile(docType)}>
                                                        <FaTrash size={10} />
                                                    </button>
                                                </div>
                                                {uploadProgress[docType] > 0 && uploadProgress[docType] < 100 && (
                                                    <div className="text-center">
                                                        <FaSpinner className="fa-spin text-success mb-1" size={14} />
                                                        <p className="mb-0 small" style={{ fontSize: '0.65rem' }}>Uploading... {uploadProgress[docType]}%</p>
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Profile;